import {Routes, Route} from "react-router-dom";

// page
import Users from "../../pages/dashboard/users/Users";

const UsersRoutes = () =>{
    return(
        <Routes>
            <Route
                path="/" element={<Users/>}
            />
        </Routes>
    );
}

export default UsersRoutes;